exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-foot {\n    background: #e2ebf8 !important;\n    color: black !important;\n}\n\n.title-tr {\n    text-align: center;\n}\n\ntd{\n    text-align: center;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/area-restrita/financeiro/declaracao-rendimento-emp-fin/declaracao-rend-emp-fin-detalhe/declaracao-rend-emp-fin-detalhe.component.css
// module id = ../../../../../src/app/area-restrita/financeiro/declaracao-rendimento-emp-fin/declaracao-rend-emp-fin-detalhe/declaracao-rend-emp-fin-detalhe.component.css
// module chunks = main